export enum TimeRange {
  FiftyTwoWeeks = "52W",
  OneHundredAndFiftySixWeeks = "156W",
}
